import React from 'react'

export default function () {
  return (
    <nav>
        <ul>
            <li><a href="#" title='Monster on Instagram'><i class='bx bxl-instagram'></i></a></li>
            <li><a href="#" title='Monstercat on TikTok' ><i class='bx bxl-tiktok' ></i></a></li>
            <li><a href="#" title='Monstercat on Twitter'><i class='bx bxl-twitter' ></i></a></li>
            <li><a href="#" title='Monstercat on Twitch'><i class='bx bxl-twitch' ></i></a></li>
            <li><a href="#" title='Monstercat on Facebook'><i class='bx bxl-facebook-circle' ></i></a></li>
            <li><a href="#" title='Monstercat on Discord'><i class='bx bxl-discord' ></i></a></li>
            <li><a href="#" title='Monstercat Player'><i class='bx bx-play-circle' ></i></a></li>
        </ul>
    </nav>
  )
}
